import { FormC } from "./FormC";
import React, { useEffect, useState } from "react";
import Button from "../../../library/components/Button";
import { FormB } from "./FormB";
import { FormA } from "./FormA";
// import BarcodeScannerComponent from "react-qr-barcode-scanner";
import "./index.css";

export const PrecountingTabs = () => {
  const [defaultKey, setDefaultKey] = useState(1);
  // const [data, setData] = React.useState("");
  // const [showCameraPopop, setshowCameraPopop] = useState(false);
  // const [onCameraPopopUpdate, setonCameraPopopUpdate] = useState();
  // const [onCameraPopopError, setonCameraPopopError] = useState();

  const renderTabs = () => {
    switch (defaultKey) {
      case 1:
        return (
          <FormC
            // isShowCameraPopup={showCameraPopop}
            // onCameraPopopUpdate={onCameraPopopUpdate}
            // onCameraPopopError={onCameraPopopError}
            // setonCameraPopopUpdate={setonCameraPopopUpdate}
          />
        );
      case 2:
        return (
          <FormA
            // isShowCameraPopup={showCameraPopop}
            // onCameraPopopUpdate={onCameraPopopUpdate}
            // onCameraPopopError={onCameraPopopError}
            // setonCameraPopopUpdate={setonCameraPopopUpdate}
          />
        );
      default:
        return (
          <FormB
            // isShowCameraPopup={showCameraPopop}
            // onCameraPopopUpdate={onCameraPopopUpdate}
            // onCameraPopopError={onCameraPopopError}
            // setonCameraPopopUpdate={setonCameraPopopUpdate}
          />
        );
    }
  };
  return (
    <div className="row">
      <div className="col-md-5 col-lg-4 tab">
        <div className="row preCountingTabs">
          <ul>
            <li>
              <Button
                onClick={() => setDefaultKey(1)}
                btnClass={defaultKey === 1 ? "active-btn" : "list-button"}
                value={"Scan Form 13-C"}
              />
            </li>
            <li>
              <Button
                onClick={() => setDefaultKey(2)}
                btnClass={defaultKey === 2 ? "active-btn" : "list-button"}
                value={"Scan Form 13-A"}
              />
            </li>
            <li>
              <Button
                onClick={() => setDefaultKey(3)}
                btnClass={defaultKey === 3 ? "active-btn" : "list-button"}
                value={"Scan Form 13-B"}
              />
            </li>
          </ul>
        </div>
        {/* <p>{data}</p> */}
        <div className="row">
          <div className="row scanner-view">
            <div className="scanner">
              {/* Web Cam Code */}
              {/* {showCameraPopop && (
                <BarcodeScannerComponent
                  width={300}
                  onUpdate={(err, result) => {
                    if(err){
                        setonCameraPopopError(err)
                    }
                    if (result && result.text){
                        setonCameraPopopUpdate(result.text)
                        setshowCameraPopop(!showCameraPopop)
                    }
                  }}
                  onError={(err) =>{
                    setonCameraPopopError(err)
                  }}
                />
              )} */}
            </div>

            {/* <Button
              value={"Click to enable WebCam"}
              btnClass={"config-btn"}
              // onClick={() => setshowCameraPopop(!showCameraPopop)}
            /> */}
            {/* <div class="toggle-switch">
              <input
                class="toggle-input"
                id="toggle"
                type="checkbox"
                onClick={() => setshowCameraPopop(!showCameraPopop)}
                checked={showCameraPopop}
              />
              <label class="toggle-label" for="toggle"></label>
            </div> */}
          </div>
        </div>
      </div>
      <div className="col-md-7 col-lg-8 p-0">{renderTabs()}</div>
    </div>
  );
};

export default PrecountingTabs;
